@use "~theme/breakpoints";

.mobileHeader {
  @include breakpoints.desktop {
    display: none;
  }
}
